import { render, staticRenderFns } from "./LearningCardContent.vue?vue&type=template&id=09d52756&"
import script from "./LearningCardContent.vue?vue&type=script&lang=js&"
export * from "./LearningCardContent.vue?vue&type=script&lang=js&"
import style0 from "./LearningCardContent.vue?vue&type=style&index=0&id=09d52756&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports